import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PlaceOrderComponent } from './place-order.component';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { QuoteModule } from './quote/quote.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GroupInfoModule } from './group-info/group-info.module';
import { AccountantInfoModule } from './accountant-info/accountant-info.module';
import { UserInfoModule } from './user-info/user-info.module';
import { EffectiveRangeModule } from './effective-range/effective-range.module';
import { PaymentTypeModule } from './payment-type/payment-type.module';
import { CostDetailsModule } from './cost-details/cost-details.module';
import { SelectLicenseModule } from './select-license/select-license.module';
import { SelectSmsModule } from './select-sms/select-sms.module';
import { SelectCrawlModule } from './select-crawl/select-crawl.module';
import { ToExistingGroupModule } from './to-existing-group/to-existing-group.module';
import { CommentModule } from './comment/comment.module';
import { CostTableModule } from './cost-table/cost-table.module';

@NgModule({
  declarations: [
    PlaceOrderComponent
  ],
  imports: [
    CommonModule,
    
    FormsModule, ReactiveFormsModule,
    PopoverModule.forRoot(),
    
    GroupInfoModule,
    ToExistingGroupModule,
    SelectLicenseModule, SelectSmsModule, SelectCrawlModule,
    EffectiveRangeModule, CostDetailsModule, CostTableModule, PaymentTypeModule, 
    AccountantInfoModule,
    UserInfoModule,
    CommentModule,
    QuoteModule,
  ],
  exports: [
    CommonModule,
    FormsModule, ReactiveFormsModule,
    PopoverModule,
    
    GroupInfoModule,
    ToExistingGroupModule,
    SelectLicenseModule, SelectSmsModule, SelectCrawlModule,
    EffectiveRangeModule, CostDetailsModule, CostTableModule, PaymentTypeModule, 
    AccountantInfoModule,
    UserInfoModule,
    CommentModule,
    QuoteModule,

  ]
})
export class PlaceOrderModule { }
